var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedincolored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_32983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8146 4.00104H5.18069C4.53631 3.99379 4.00788 4.50998 4 5.15435V18.8452C4.00763 19.4899 4.536 20.0065 5.18062 19.9998H18.8146C19.4606 20.0078 19.9911 19.4911 20 18.8452V5.15329C19.9908 4.50767 19.4603 3.99154 18.8146 3.99998",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6328 17.6328H15.2621V13.9202C15.2621 13.0348 15.2463 11.8952 14.0291 11.8952C12.7943 11.8952 12.6054 12.8598 12.6054 13.8557V17.6326H10.2347V9.99784H12.5106V11.0412H12.5424C12.7702 10.6518 13.0993 10.3314 13.4947 10.1142C13.8902 9.89704 14.3371 9.79117 14.7879 9.8079C17.1908 9.8079 17.6338 11.3884 17.6338 13.4445L17.6328 17.6328ZM7.55975 8.95428C6.79994 8.9544 6.18387 8.33853 6.18375 7.57871C6.18362 6.8189 6.79944 6.20284 7.55925 6.20271C8.31906 6.20253 8.93512 6.8184 8.93525 7.57821C8.93532 7.94309 8.79044 8.29305 8.53248 8.55111C8.27453 8.80917 7.92463 8.95419 7.55975 8.95428ZM8.74512 17.6329H6.37194V9.99784H8.74506V17.6328L8.74512 17.6329ZM18.8146 4.00103H5.18069C4.53631 3.99378 4.00788 4.50996 4 5.15434V18.8452C4.00763 19.4898 4.536 20.0065 5.18062 19.9998H18.8146C19.4606 20.0078 19.9911 19.4911 20 18.8452V5.15328C19.9908 4.50765 19.4603 3.99153 18.8146 3.99996",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_32983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedincolored);
export default __webpack_public_path__ + "static/media/linkedincolored.ce84ab241f3ff195f111271827a392b3.svg";
export { ForwardRef as ReactComponent };